import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { numberWithCommas, formatDollar } from '../../util/functions';

function geTradeSummaryStats (totalSummary) {
  totalSummary = totalSummary || {};
  const lastExecTime = totalSummary.lastExecTime ? moment(totalSummary.lastExecTime).format('LTS') : null;
  const lastExecTimeHeader = totalSummary.lastExecTime ? 'As of ' + moment(totalSummary.lastExecTime).format('ll') : 'As of';

  let summary =
    [
      {
        name: 'Trades',
        value: totalSummary.tradeCount ? numberWithCommas(totalSummary.tradeCount) : '-'
      },
      {
        name: 'Volume',
        value: totalSummary.volume ? numberWithCommas(totalSummary.volume) : '-'
      },
      {
        name: 'Notional',
        value: totalSummary.notional ? formatDollar(totalSummary.notional) : '-'
      },
      {
        name: lastExecTimeHeader,
        value: lastExecTime || '-'
      }

    ];
  return summary;
}

class TradeStatsHeader extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      tradeTotalStats: null
    };
  }

  render () {
    const stats = geTradeSummaryStats(this.props.tradeTotalStats);
    const title = this.props.title;
    return (
      <>
        <div key={title + 'Div'} className={this.props.titleStyle} >{title}</div>
        {stats && stats.map((stat, i) => stat.value !== undefined &&
        <div key={stat.name} className={this.props.valueStyle}><span>{stat.value}</span></div>)}
      </>

    );
  }
}

TradeStatsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  titleStyle: PropTypes.any,
  valueStyle: PropTypes.any,
  tradeTotalStats: PropTypes.object

};

export default TradeStatsHeader;
